module.exports = __webpack_public_path__ + "static/media/god.fb70fee5.gif";